module.exports = __webpack_public_path__ + "static/img/databg.813b3ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/databg.png
// module id = GHiL
// module chunks = 0